import { jsx as _jsx } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { MYPAGE_PASSES, SOLVOOK_WRITE_STUDIO } from "@/settings/constant";
import { ConfirmDialog } from "@bookips/sds";
import { useRouter } from "next/router";
/**
 * 이용권 구매 페이지의 텍스트형 confirm 다이얼로그.
 * 종류별로 컴포넌트를 만들지 않고 config map 하나로 처리한다.
 * (본문·레이아웃이 있는 다이얼로그는 PassNoticeDialog / PassInfoDialog 처럼 별도 컴포넌트로 분리)
 *
 * 라우팅·mixpanel 처럼 다이얼로그 자체에 속한 동작은 이 안에서 끝내고, 호출부는 type 만 넘긴다.
 */ const PassConfirmDialog = (param)=>{
    let { type , onClose  } = param;
    const { push  } = useRouter();
    const configs = {
        // 선택한 과목/학년에 판매중인 이용권이 없을 때. 닫힌 뒤의 탭 초기화는 호출부(onClose)가 담당한다.
        preparing: {
            title: "상품을 준비중이에요.",
            confirmText: "확인"
        },
        // 월구독 이용권 도입 시 사용할 안내. 현재 PassItem 에 호출부가 연결되어 있지 않아 노출되지 않는다.
        alreadySubscribed: {
            title: "이미 구독중인 상품이에요.",
            description: "상품의 구독정보를 보고 싶으시다면 '이용권 관리 가기'를 눌러주세요.",
            confirmText: "확인",
            cancelText: "이용권 관리 가기",
            onConfirm: ()=>{
                // mx-9
                mixpanelEvent("Popup Button Clicked", {
                    "Popup Type": "Already Subscribed",
                    "Popup Title": "이미 구독중인 상품이에요",
                    "Button Name": "확인",
                    "Button URL": null
                });
            },
            onCancel: ()=>{
                // mx-9
                mixpanelEvent("Popup Button Clicked", {
                    "Popup Type": "Already Subscribed",
                    "Popup Title": "이미 구독중인 상품이에요",
                    "Button Name": "이용권 관리 가기",
                    "Button URL": MYPAGE_PASSES
                });
                push(MYPAGE_PASSES);
            }
        },
        // 쏠북 플러스는 판매 종료됐지만, 아직 만료되지 않은(unexpired) 보유자에게는 여전히
        // "쏠북 플러스 기간 동안 엑스퍼트 추가 결제 불필요"가 성립한다.
        // 보유자가 모두 만료된 것이 확인되기 전까지는 엑스퍼트 중복 결제를 막기 위해 유지한다.
        // (호출부: PassList 의 unexpired 쏠북플러스 보유 체크)
        existSolvookPlus: {
            title: "이미 쏠북 플러스를 이용 중이에요.",
            description: "쏠북 플러스 기간동안 엑스퍼트는 추가 결제없이 사용할 수 있어요.",
            confirmText: "엑스퍼트 사용하기",
            cancelText: "확인",
            onConfirm: ()=>{
                // mx-9
                mixpanelEvent("Popup Button Clicked", {
                    "Popup Type": "Already Subscribed",
                    "Popup Title": "이미 쏠북 플러스를 이용 중이에요",
                    "Button Name": "엑스퍼트 사용하기",
                    "Button URL": SOLVOOK_WRITE_STUDIO
                });
                push(SOLVOOK_WRITE_STUDIO);
            },
            onCancel: ()=>{
                // mx-9
                mixpanelEvent("Popup Button Clicked", {
                    "Popup Type": "Already Subscribed",
                    "Popup Title": "이미 쏠북 플러스를 이용 중이에요",
                    "Button Name": "확인",
                    "Button URL": null
                });
            }
        }
    };
    if (!type) return null;
    const { onConfirm , onCancel , ...config } = configs[type];
    return /*#__PURE__*/ _jsx(ConfirmDialog, {
        ...config,
        open: true,
        onOpenChange: (open)=>!open && onClose(),
        // SDS ConfirmDialog 는 확인 버튼에서 스스로 닫지 않으므로 여기서 닫아준다.
        onConfirm: ()=>{
            onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm();
            onClose();
        },
        // 취소 버튼은 SDS 내부에서 onCancel 실행 후 onOpenChange(false) 를 호출하므로 닫기가 이미 걸려 있다.
        onCancel: onCancel
    });
};
export default PassConfirmDialog;
